import React, { useState, useRef, useEffect } from 'react';
import { useI18n } from '../i18n';

const options = [
  { value: 'en', label: 'English - EN', flag: '🇺🇸' },
  { value: 'es', label: 'Español - ES', flag: '🇪🇸' },
];

const LanguageSelector = ({ lang, onChange }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const active = options.find((o) => o.value === lang) || options[0];

  return (
    <div className="lang-select" ref={ref}>
      <button
        className={`lang-select-toggle ${open ? 'open' : ''}`}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={t('flag_label')}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="lang-flag" aria-hidden="true">{active.flag}</span>
        <span className="lang-code">{active.value.toUpperCase()}</span>
        <span className="lang-caret" aria-hidden="true">▾</span>
      </button>
      {open && (
        <div className="lang-select-menu" role="listbox" aria-label={t('flag_label')}>
          <div className="lang-select-title">{t('flag_label')}</div>
          {options.map((o) => (
            <button
              key={o.value}
              role="option"
              aria-selected={o.value === lang}
              className={`lang-select-item ${o.value === lang ? 'selected' : ''}`}
              onClick={() => {
                onChange(o.value);
                setOpen(false);
              }}
            >
              <span className="lang-item-flag" aria-hidden="true">{o.flag}</span>
              <span className="lang-item-label">{o.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
